import {BranchDto} from "./branch.dto";
import {ConfigLevel} from "./interfaces/config-level";
import {ConfigLevelType} from "./enums/config-level-type.enum";
import {Serialisable} from "../serialisable";

export class ConfigDto extends Serialisable implements ConfigLevel {
    id: number;

    isLive: boolean;
    name: string;
    getDisplayName(): string {
        return this.name;
    }
    guid: string;
    path: string;

    createdDateUtc: Date;
    offlineCacheDateUtc: Date;

    branches: BranchDto[];

    minVersion: string;
    maxVersion: string;

    canUseCloudDeployments: boolean;

    configLevel = ConfigLevelType.Config;
    getChildren(): ConfigLevel[] {
        return this.branches;
    }
    setChildren(value: BranchDto[]): void {
        this.branches = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/config.dto.ts